// if you have a list of objects and an object of filters
// like
//
// let listOfObjects = [
//   {type: 1, color: 'red', shape: 'rect'},
//   {type: 1, color: 'blue', shape: 'circle'}, 
//   {type: 1, color: 'blue', 'polygon'}
// ]
//
// and
//
// let filters = { 
//  color: blue 
// }
//
// it creates a a new listOfFilteredObjects 
// that matches the criteria
//
// let listOfFilteredObjects = applyFilters(filters, listOfObjets)
//
// yields
//
// => [{type: 1, color: 'blue', shape: 'circle'}, {type: 1, color: 'blue', 'polygon'}]

export function applyFilters (filterSet, initialData) {
  if (filterSet === {}) return initialData

  return initialData.filter(item => {
    for (let key in filterSet) {
      // ignore filterKey not in the data set
      if (item[key] === undefined) return true
      // filter
      if (item[key] != filterSet[key]) return false
    }
    return true
  })
}

export default { applyFilters }